import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface LogoutModalProps {
    show: boolean;
    errorMessage: string;
    onLogout: () => void;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({
    show,
    errorMessage,
    onLogout
}) => {
    const navigate = useNavigate();

    return (
        <Modal
            centered
            show={show}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>Sign out?</Modal.Title>
            </Modal.Header>
            <Modal.Body>{errorMessage}</Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={() => navigate("/", { replace: true })}
                >
                    Close
                </Button>
                <Button variant="primary" onClick={onLogout}>
                    Sign Out
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
